import { authHeader } from "./auth";

//  const API ="http://localhost:5050";
  const API = "https://oizvehadar.cloud/nodejs";

export const adminLogin = async (email, password) => {
 const res = await fetch(`${API}/api/auth/login`,{method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify( { email, password })});
    const data = await res.json();

  if (!res.ok) {
    throw new Error(data.error );
  }

  return data;
};
export const fetchSubjects = async () => {
  const res = await fetch(`${API}/api/subjects/`, {
    // headers: authHeader(),
  });
  return res.json();
};
export const fetchUsers = async () => {
  const res = await fetch(`${API}/admin/users`, {
    headers: authHeader(),
  });
  return res.json();
};

export const setUserActive = async (id, active) => {
  const res = await fetch(`${API}/admin/users/${id}/active`, {
    method: "PATCH",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify({ active }),
  });
  return res.json();
};

export const sendActivatedEmail = async (email, lang = "en") => {
    // console.log({email, lang});
  const res = await fetch(`${API}/api/email/activated`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify({ email, lang }),
  });

  const data = await res.json();
  if (!res.ok) throw new Error(data.error || "Failed to send activation email");
  return data;
};

export const sendDeactivatedEmail = async (email, lang = "en") => {
  const res = await fetch(`${API}/api/email/deactivated`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify({ email, lang }),
  });

  const data = await res.json();
  if (!res.ok) throw new Error(data.error || "Failed to send deactivation email");
  return data;
};


// ===================== TOPICS =====================

// Get topics by subject slug
export const fetchTopicsBySubject = async (subjectSlug) => {
  // console.log(subjectSlug)
  const res = await fetch(`${API}/api/topics/${subjectSlug}`, {
    // headers: authHeader(),
  });

  const data = await res.json();
  // console.log(data);
  if (!res.ok) throw new Error(data.error || "Failed to fetch topics");
  return data;
};

// Create topic
export const createTopic = async (payload) => {
  const res = await fetch(`${API}/api/topics`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(payload),
  });

  const data = await res.json();
  if (!res.ok) throw new Error(data.error || "Failed to create topic");
  return data;
};

// Update topic
export const updateTopic = async (id, payload) => {
  const res = await fetch(`${API}/api/topics/${id}`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(payload),
  });

  const data = await res.json();
  if (!res.ok) throw new Error(data.error || "Failed to update topic");
  return data;
};

// Delete topic
export const deleteTopic = async (id) => {
  const res = await fetch(`${API}/api/topics/${id}`, {
    method: "DELETE",
    headers: authHeader(),
  });

  const data = await res.json();
  if (!res.ok) throw new Error(data.error || "Failed to delete topic");
  return data;
};
// ===================== STORIES =====================

// Get all stories for topic
export const fetchStoriesByTopic = async (topicId) => {
  const res = await fetch(`${API}/api/stories/${topicId}`, {
    headers: authHeader(),
  });

  const data = await res.json();
  if (!res.ok) throw new Error(data.error || "Failed to fetch stories");
  return data;
};
export const fetchStoryById = async (topicId) => {
  // console.log(topicId)
  const res = await fetch(`${API}/api/stories/byId/${topicId}`, {
    headers: authHeader(),
  });

  const data = await res.json();
  if (!res.ok) throw new Error(data.error || "Failed to fetch stories");
  return data;
};

// Create story
export const createStory = async (payload) => {
  const res = await fetch(`${API}/api/stories`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(payload),
  });

  const data = await res.json();
  if (!res.ok) throw new Error(data.error || "Failed to create story");
  return data;
};

// Update story
export const updateStory = async (id, payload) => {
  const res = await fetch(`${API}/api/stories/${id}`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(payload),
  });

  const data = await res.json();
  if (!res.ok) throw new Error(data.error || "Failed to update story");
  return data;
};

// Delete story
export const deleteStory = async (id) => {
  const res = await fetch(`${API}/api/stories/${id}`, {
    method: "DELETE",
    headers: authHeader(),
  });

  const data = await res.json();
  if (!res.ok) throw new Error(data.error || "Failed to delete story");
  return data;
};
export async function fetchDates() {
  const res = await fetch(`${API}/api/topics/dates`);
  if (!res.ok) throw new Error("Failed to load dates");
  return res.json();
}

export async function createDate(date) {
  const res = await fetch(`${API}/api/topics/dates`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ date }),
  });
  if (!res.ok) throw new Error("Failed to create date");
  return res.json();
}

export async function updateDate(oldDate, newDate) {
  const res = await fetch(`${API}/api/topics/dates`, {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ oldDate, newDate }),
  });
  if (!res.ok) throw new Error("Failed to update date");
}
export async function updateDateOrder(items) {
  const res = await fetch(`${API}/api/topics/dates/order`, {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ items }),
  });

  if (!res.ok) throw new Error("Failed to update order");
}

export async function deleteDate(date) {
  const res = await fetch(`${API}/api/topics/dates/${encodeURIComponent(date)}`, {
    method: "DELETE",
  });
  if (!res.ok) throw new Error("Failed to delete date");
}


export const fetchSubscriptions = async () => {
  const res = await fetch(`${API}/api/subscriptions`, {
    headers: authHeader(),
  });

  const data = await res.json();
  if (!res.ok) throw new Error(data.error || "Failed to fetch subscriptions");
  return data;
};

export const createSubscription = async (payload) => {
  const res = await fetch(`${API}/api/subscriptions`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(payload),
  });

  const data = await res.json();
  if (!res.ok) throw new Error(data.error || "Failed to create subscription");
  return data;
};

export const updateSubscription = async (id, payload) => {
  const res = await fetch(`${API}/api/subscriptions/${id}`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(payload),
  });

  const data = await res.json();
  if (!res.ok) throw new Error(data.error || "Failed to update subscription");
  return data;
};

export const deleteSubscription = async (id) => {
  const res = await fetch(`${API}/api/subscriptions/${id}`, {
    method: "DELETE",
    headers: authHeader(),
  });

  const data = await res.json();
  if (!res.ok) throw new Error(data.error || "Failed to delete subscription");
  return data;
};

export async function fetchUserSubscriptions() {
  const res = await fetch(`${API}/api/admin-user-subscriptions/admin/all`, {
    headers: authHeader(),
  });

  const data = await res.json();
  if (!res.ok) throw new Error(data.message || "Failed to fetch user subscriptions");
  return data;
}

export async function createUserSubscription(payload) {
  const res = await fetch(`${API}/api/admin-user-subscriptions/admin/add`, {
    method: "POST",
    headers: authHeader(),
    body: JSON.stringify(payload),
  });

  const data = await res.json();
  if (!res.ok) throw new Error(data.message || "Failed to create user subscription");
  return data;
}

export async function updateUserSubscription(id, payload) {
  const res = await fetch(`${API}/api/admin-user-subscriptions/admin/${id}`, {
    method: "PUT",
    headers: authHeader(),
    body: JSON.stringify(payload),
  });

  const data = await res.json();
  if (!res.ok) throw new Error(data.message || "Failed to update user subscription");
  return data;
}

export async function deleteUserSubscription(id) {
  const res = await fetch(`${API}/api/admin-user-subscriptions/admin/${id}`, {
    method: "DELETE",
    headers: authHeader(),
  });

  const data = await res.json();
  if (!res.ok) throw new Error(data.message || "Failed to delete user subscription");
  return data;
}